// extracted by mini-css-extract-plugin
export default {"subText":"Input_subText__An2fZ","input":"Input_input__SCIDp","classLabel":"Input_classLabel__isWqT"};